export default __webpack_public_path__ + "static/media/400-500.5411991b.jpg";